import React, { useEffect, useRef, useState } from 'react'
import _ from 'underscore'

import styled from 'styled-components'

import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'

type Props = {
  label: string | React.ReactNode,
  value?: string | number | boolean | React.ReactNode,
  tooltip?: string,
  className?: string
  hideIfValueIsNull?: boolean
}

const ColumnItem = ({ label, value = null, tooltip, className, hideIfValueIsNull = false }: Props) => {
  const displayValue = _.isBoolean(value) ? value.toString() : value
  const displayValueRef = useRef<HTMLDivElement | null>(null)
  const [tooltipDisplayValue, setTooltipDisplayValue] = useState<string>('')

  const IsEllipsisActive = (textContainer: HTMLDivElement | null) => {
    if (textContainer) {
      return (textContainer.offsetWidth < textContainer.scrollWidth)
    }
  }

  useEffect(() => {
    if (IsEllipsisActive(displayValueRef.current)) {
      setTooltipDisplayValue(_.isNull(value) ? '' : value.toString())
    }
  }, [value])

  if (hideIfValueIsNull && value === null) {
    return null
  }

  return (
    <S.ColumnItem {...{ className }}>
      {
        tooltip
          ? (
            <Tooltip title={tooltip}>
              <S.Label>{label}</S.Label>
            </Tooltip>
          )
          : <S.Label>{label}</S.Label>
      }
      <Tooltip title={tooltipDisplayValue}>
        <S.Value ref={displayValueRef}>{displayValue !== null ? displayValue : '--'}</S.Value>
      </Tooltip>
    </S.ColumnItem>
  )
}

export default ColumnItem

const S = {
  ColumnItem: styled.div`
    display: grid;
    grid-template-columns: 60% 40%;
    grid-gap: 2px;
    align-items: center;
    width: 100%;
    text-transform: capitalize;
    font-size: 0.85rem;
    padding-bottom: 5px;
    margin-top: 10px;
  `,
  Label: styled.label`
    padding-right: 5px;
    padding-left: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
    color: ${color('panelFieldLabel')};
    white-space: nowrap;
  `,
  Value: styled.div`
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 700;
    white-space: normal;
    padding-right: 2px;
  `
}
